import 'Plugins/customFormsPlugin';

// initialize custom form elements
export default function initCustomForms() {
	jcf.setOptions('Select', {
		wrapNative: false,
		wrapNativeOnMobile: false,
	});
	jcf.replaceAll();
}